import _implicitStylesheets from "./watchDemo.css";
import _implicitScopedStylesheets from "./watchDemo.scoped.css?scoped=true";
import _axImage from "ax/image";
import _axIcon from "ax/icon";
import _axButton from "ax/button";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img class="watch-demo__preview${0}"${"a0:src"} alt=""${2}>`;
const $fragment2 = parseFragment`<h4${"a0:id"} class="watch-demo__title${0}" type-style="display-6" data-testid="watch-demo-title"${2}>${"t1"}</h4>`;
const stc0 = {
  classMap: {
    "watch-demo__media": true
  },
  attrs: {
    "aria-hidden": "true"
  },
  key: 1
};
const stc1 = {
  "watch-demo__icon": true
};
const stc2 = {
  classMap: {
    "watch-demo__content": true
  },
  key: 5
};
const stc3 = {
  "watch-demo__cta": true
};
const stc4 = {
  "data-testid": "watch-demo-cta"
};
const stc5 = {
  slotAssignment: "start",
  props: {
    "icon": "new_window",
    "size": "medium",
    "ariaHidden": "true"
  },
  key: 10
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, gid: api_scoped_id, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, d: api_dynamic_text, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("section", {
    className: api_normalize_class_name($cmp.watchDemoClass),
    attrs: {
      "aria-labelledby": api_scoped_id("watch-demo-heading"),
      "data-testid": "watch-demo"
    },
    key: 0
  }, [api_element("div", stc0, [$cmp.youtubeVideoId ? api_static_fragment($fragment1, 3, [api_static_part(0, {
    attrs: {
      "src": $cmp.mediaSrc
    }
  }, null)]) : null, !$cmp.youtubeVideoId ? api_custom_element("ax-image", _axImage, {
    classMap: stc1,
    props: {
      "imgSrc": $cmp.mediaSrc,
      "width": "70px",
      "height": "70px",
      "alt": ""
    },
    key: 4
  }) : null]), api_element("div", stc2, [api_static_fragment($fragment2, 7, [api_static_part(0, {
    attrs: {
      "id": api_scoped_id("watch-demo-heading")
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.heading))]), api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    classMap: stc3,
    props: {
      "type": "button",
      "buttonType": "watch_demo",
      "context": $cmp.watchDemoAnalyticsContext
    },
    key: 8
  }, [api_custom_element("ax-button", _axButton, {
    attrs: stc4,
    props: {
      "text": $cmp.label,
      "size": "large",
      "variant": "primary",
      "disabled": $cmp.isPlaceholder
    },
    key: 9,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc5)])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-49ul8asseg5";
tmpl.legacyStylesheetToken = "undefined-_watchDemo";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
